import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/react-hooks';

import 'prismstyles.scss'
import '@prism/styles/prism.comps.min.css';
import '@prism/styles/icon-font.min.css';
import 'globalstyles.scss';

import client from 'graphql/client';

import App from './App';

import store from './redux/store';
import { runtimeEnv } from './utils/runtimeEnv';

// Load the Adobe Launch script at runtime from the env-correct URL.
// Previously baked into public/index.html via %REACT_APP_URL_TRACKING% —
// which broke "build once, deploy many" (a single image would carry the
// prod Launch URL into uat). Loading it here from runtimeEnv keeps the
// bundle env-agnostic; the URL is resolved from window.__ENV__ (injected
// by the backend into index.html at serve time).
if (runtimeEnv.urlTracking && !document.getElementById('adobe-launch-script')) {
  const s = document.createElement('script');
  s.id = 'adobe-launch-script';
  s.src = runtimeEnv.urlTracking;
  s.async = true;
  document.head.appendChild(s);
  console.log('The environment is running:', runtimeEnv.envName);
}

ReactDOM.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <App />
    </Provider>
  </ApolloProvider>,
  document.getElementById('ams-clientapp-root')
);
